"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.optional = void 0;
var internals_1 = require("./internals");
// region optional & strict
/**
 * Even if the parser returns `undefined`, the parsing process will not be stopped.
 * It's used to parse for types with optional keys
 */
var optional = function (p) { return ({
    __type: "optional",
    fn: p,
}); };
exports.optional = optional;
function parse(parsers, object) {
    return object === undefined
        ? function (o) { return internals_1._parse(parsers, o); }
        : internals_1._parse(parsers, object);
}
exports.parse = parse;
// endregion
